__turbopack_context__.v({
  "imageDescription": "ResearchSection-module__d4PDwq__imageDescription",
});
